// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___850267682f1baaf41d1","cls2":"Unibrow-cls2___0b3bb00f63cb6e09e84 Unibrow-cls1___850267682f1baaf41d1"};